import {action, makeObservable, observable} from 'mobx';
import Get from 'app/utils/Get';
import {getLinkPath} from 'app/utils';
import ArticleInterface from 'app/interfaces/articles/ArticleInterface';

export interface FaqInterface {
    title: string
    text: string
    name: string
}

export class FaqStore {
    @observable faqs: FaqInterface[] = [];

    @observable asideHiddenTemples: ArticleInterface[] = [];

    @observable loading: boolean = true;

    constructor() {
        makeObservable(this);
    }

    @action
    init(faqs: FaqInterface[]): void {
        this.faqs = faqs;
        this.setLoading(false);
    }

    @action
    setLoading(loading: boolean): void {
        this.loading = loading;
    }

    @action
    updateHiddenTemples = (temples: ArticleInterface[]): void => {
        this.asideHiddenTemples = temples;
    };

    loadData(): void {
        new Get({
            url: getLinkPath('/faq')
        })
            .execute()
            .then(response => response.json())
            .then(response => this.init(response));
    }
}
